<template>
    <div class="trading-tools">
        <div class="trading-tools__tabs">
            <a
                v-for="tab in tabs"
                href="#"
                :key="tab.key"
                @click.prevent="selectTab(tab)"
                :class="{'active': tab === selectedTab}"
            >{{ tab.title }}</a>
        </div>
        <div class="f-block f-block-light f-block-overflow">
            <table class="trading-tools__table">
                <thead>
                    <tr>
                        <td>
                            <input 
                                v-model.trim="searchPhrase"
                                class="trading-tools__table-search" 
                                :placeholder="gettext('tpl:pages:forex:trading_tools:table:search_placeholder')"
                            >
                        </td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:lot') }}</td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:pip') }}</td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:step') }}</td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:hours') }}</td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:long') }}</td>
                        <td class="d-none d-lg-table-cell">{{ gettext('tpl:pages:forex:trading_tools:table:short') }}</td>
                    </tr>
                    <tr>
                        <td class="trading-tools__table-tab-title">{{ selectedTab.title }}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in filteredList"
                        :key="item.symbol"
                        class="trading-tools__table-item"
                        :class="{'toggled': toggledItems[item.symbol]}"
                        @click="toggledItems[item.symbol] = !toggledItems[item.symbol]"
                    >
                        <td>
                            <div class="trading-tools__table-item-symbol">{{ item.symbol }}</div>
                            <div class="trading-tools__table-item-name">{{ item.name }}</div>
                            <i class="trading-tools__table-item-arrow la la-angle-down"></i>
                            <div class="trading-tools__table-item-data">
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:lot') }}</div>
                                    <div class="trading-tools__table-item-data-row-value">{{ item.lot }}</div>
                                </div>
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:pip') }}</div>
                                    <div class="trading-tools__table-item-data-row-value">{{ item.pip }}</div>
                                </div>
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:step') }}</div>
                                    <div class="trading-tools__table-item-data-row-value">{{ item.step }}</div>
                                </div>
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:hours') }}</div>
                                    <div class="trading-tools__table-item-data-row-value trading-tools__table-item-data-row-value_type_hours">{{ item.hours }}</div>
                                </div>
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:long') }}</div>
                                    <div class="trading-tools__table-item-data-row-value">{{ item.long }}</div>
                                </div>
                                <div class="trading-tools__table-item-data-row">
                                    <div class="trading-tools__table-item-data-row-label">{{ gettext('tpl:pages:forex:trading_tools:table:short') }}</div>
                                    <div class="trading-tools__table-item-data-row-value">{{ item.short }}</div>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">{{ item.lot }}</td>
                        <td class="d-none d-lg-table-cell">{{ item.pip }}</td>
                        <td class="d-none d-lg-table-cell">{{ item.step }}</td>
                        <td class="d-none d-lg-table-cell trading-tools__table-item-cell-hours">{{ item.hours }}</td>
                        <td class="d-none d-lg-table-cell">{{ item.long }}</td>
                        <td class="d-none d-lg-table-cell">{{ item.short }}</td>
                    </tr>
                    <tr v-if="!filteredList.length">
                        <td colspan="100">{{ gettext('tpl:pages:forex:trading_tools:table:no_data') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "trading-tools",

        data() {
            return {
                selectedTab: null,
                tabs: [
                    {
                        key: 'forex',
                        title: gettext('tpl:pages:forex:trading_tools:tab:forex'),
                    },
                    {
                        key: 'commodities',
                        title: gettext('tpl:pages:forex:trading_tools:tab:commodities'),
                    },
                ],
                instruments: jsParams().instruments,
                searchPhrase: '',
                toggledItems: {}
            };
        },

        computed: {
            filteredList() {
                if (this.searchPhrase) {
                    return this.instruments[this.selectedTab.key].filter(item => {
                        return `${item.symbol} ${item.name}`.toUpperCase().indexOf( this.searchPhrase.toUpperCase() ) > -1;
                    });
                }
                else {
                    return this.instruments[this.selectedTab.key];
                }
            }
        },

        methods: {
            selectTab(tab) {
                this.selectedTab = tab
            },
        },

        created() {
            this.selectTab(this.tabs[0]);
        }
    }
</script>

<style lang="less">
</style>